import { styled } from '@mui/material/styles'
import { Box, TextField, Typography } from '@mui/material'
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

export const openedMixin = (theme, drawerwidth) => ({
  width: drawerwidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 20px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 20px)`,
  },
});

export const DrawerHeader = styled('div')(({ theme, sidemenutheme, drawerwidth }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, sidemenutheme, drawerwidth, appbarTheme }) => ({
  zIndex: 1100,
  transition: theme.transitions.create(['width', 'margin', 'background-color'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  display: 'flex',
  justifyContent: "flex-end",
  alignItems: 'center',
  height: '60px',
  background: appbarTheme?.background
    ? `linear-gradient(135deg, ${appbarTheme?.background} 0%, ${appbarTheme?.background}ee 100%)`
    : 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15), 0px 2px 6px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(10px)',
  borderBottom: `1px solid ${sidemenutheme?.secondaryColor}22`,
}));

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, sidemenutheme, drawerwidth }) => ({
    width: drawerwidth,
    height: '100%',
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '0px',
    position: 'relative',
    overflow: 'auto !important',
    // height:'100%',
    '& .MuiPaper-root': {
      padding: '10px 0px',
      height: "calc(100vh - 75px)",
      overflow: 'initial !important',
      top: '75px',
      bottom: '15px',
      left: '10px',
      margin: 'auto 0 !important',
      background: sidemenutheme?.backgroundColor || `${sidemenutheme?.secondaryColor}15` || '#ffede08f',
      boxShadow: `0px 56px 64px -16px ${sidemenutheme?.secondaryColor}55, 0px 64px 64px -32px ${sidemenutheme?.secondaryColor}66`,
      borderRadius: '28px',
      border: `1px solid ${sidemenutheme?.secondaryColor}30`,
      backdropFilter: 'blur(80px)',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        width: '0px',
        height: '0px',
        display: 'none'
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'transparent'
      },
      opacity: "1"
    },
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme, drawerwidth),
      '& .MuiDrawer-paper': openedMixin(theme, drawerwidth),
    }),
    ...(!open && {
      ...closedMixin(theme, drawerwidth),
      '& .MuiDrawer-paper': closedMixin(theme, drawerwidth),
    }),
  }),
);

